import { useMemo } from 'react';
import { useUserAuth } from '~/components/Auth';
import { logErrorToIntegrationTools } from '~/components/Tools';

import {
  checkIsManager,
  checkManagerCommandCenterEnabled,
  checkMCCAsHomepageEnabled,
} from '../helpers';
import { MANAGER_COMMAND_CENTER_ERROR_CONFIG } from './constants';

interface ManagerCommandCenterState {
  isMCCAccessible: boolean;
  mccAsHomepage: boolean;
}

export default function useManagerCommandCenter(): ManagerCommandCenterState {
  const userAuth = useUserAuth();

  return useMemo<ManagerCommandCenterState>(() => {
    const defaultState: ManagerCommandCenterState = {
      isMCCAccessible: false,
      mccAsHomepage: false,
    };

    if (!userAuth) {
      return defaultState;
    }

    try {
      const isMCCAccessible =
        checkManagerCommandCenterEnabled(userAuth) && checkIsManager(userAuth);
      return {
        isMCCAccessible,
        mccAsHomepage: checkMCCAsHomepageEnabled(userAuth) && isMCCAccessible,
      };
    } catch (error) {
      logErrorToIntegrationTools(error as Error, MANAGER_COMMAND_CENTER_ERROR_CONFIG);
      return defaultState;
    }
    // once auth is available, we don't need to recompute this
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
